import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import axiosClient from './axiosClient';
import { BASE_URL } from '../utils/helpers';

class ChatService {
    constructor() {
        this.stompClient = null;
        this.currentSubscription = null;
        this.staffNotificationSub = null;
        this.isConnecting = false; 
        this.staffListeners = new Set(); 
        this.connectionCallbacks = []; 
    }

    connect(onConnected, onError) {
        if (this.stompClient && this.stompClient.connected) {
            if (onConnected) onConnected();
            return;
        }

        if (onConnected) {
            this.connectionCallbacks.push(onConnected);
        }

        if (this.isConnecting) return;
        this.isConnecting = true;
        
        const wsUrl = `${BASE_URL}/ws/chat`;
        const socket = new SockJS(wsUrl);
        
        this.stompClient = new Client({
            webSocketFactory: () => socket,
            reconnectDelay: 5000,
            heartbeatIncoming: 4000,
            heartbeatOutgoing: 4000
        });

        this.stompClient.onConnect = (frame) => {
            this.isConnecting = false;
            this.connectionCallbacks.forEach(cb => cb());
            this.connectionCallbacks = [];
        };

        this.stompClient.onStompError = (frame) => {
            this.isConnecting = false;
            if (onError) onError(frame);
        };

        this.stompClient.onWebSocketError = (event) => {
            this.isConnecting = false;
        };

        this.stompClient.activate();
    }

    disconnect() {
        if (this.stompClient !== null) {
            this.stompClient.deactivate();
        }
        this.isConnecting = false;
    }

    sendMessage(messageDto) {
        if (this.stompClient && this.stompClient.connected) {
            this.stompClient.publish({
                destination: '/app/chat.sendMessage',
                body: JSON.stringify(messageDto)
            });
        }
    }

    subscribeToRoom(roomId, onMessageReceived) {
        if (!this.stompClient || !this.stompClient.connected) return;
        if (this.currentSubscription) {
            this.currentSubscription.unsubscribe();
        }
        this.currentSubscription = this.stompClient.subscribe(`/topic/room.${roomId}`, (payload) => {
            const message = JSON.parse(payload.body);
            onMessageReceived(message);
        });
    }

    unsubscribeFromRoom() {
        if (this.currentSubscription) {
            this.currentSubscription.unsubscribe();
            this.currentSubscription = null;
        }
    }

    subscribeToStaffNotifications(callback) {
        this.staffListeners.add(callback);

        if (!this.stompClient || !this.stompClient.connected) {
            return () => {
                this.staffListeners.delete(callback);
            };
        }

        if (!this.staffNotificationSub) {
            this.staffNotificationSub = this.stompClient.subscribe('/topic/staff.notifications', (payload) => {
                const message = JSON.parse(payload.body);
                this.staffListeners.forEach(listener => listener(message));
            });
        }

        return () => {
            this.staffListeners.delete(callback);
        };
    }

    getGuestHistory(guestId) { return axiosClient.get(`/chat/history/guest/${guestId}`); }
    getUserHistory(accountId) { return axiosClient.get(`/chat/history/user/${accountId}`); }
    getActiveRooms() { return axiosClient.get(`/chat/staff/rooms?t=${Date.now()}`); }
    getRoomHistoryForStaff(roomId) { return axiosClient.get(`/chat/staff/history/${roomId}`); }
    markRoomAsRead(roomId) { return axiosClient.patch(`/chat/staff/rooms/${roomId}/read`); }
}

const chatService = new ChatService();
export default chatService;